const Divider = {
  defaultProps: {
    color: 'var(--mantine-color-border)',
  },
}

export default Divider
